import styled from 'styled-components';

// We removed this checkbox in latest designs.
// But may bring it back. So "hiding" it for now.
export const CheckIconContainer = styled.div`
  width: 24px;
  height: 24px;
  margin-right: 8px;
  display: none;
`;

export const ButtonComponent = styled.button<{
  disabled?: boolean;
  variant?: string;
  $loading?: boolean;
  full?: boolean;
  noStylingHover?: boolean;
  done?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({
    theme: {
      borderRadius: { full },
    },
  }) => full};
  font-weight: 700;
  padding: 0 2.4rem;
  white-space: nowrap;
  height: 45px;
  :active {
    opacity: 0.8;
  }
  ${({
    $loading,
    theme: {
      colors: {
        gradients: { loading },
        functional: { white },
      },
    },
  }) =>
    $loading &&
    `
    border: none;
    cursor: auto;
    & { color: ${white}; } 
    & { background: ${loading} }
    background-position: 0 0;
    animation: gradientX 0.5s ease-in-out infinite;
    :hover {
      opacity: 1;
    };
    pointer-events: none;
  `};

  ${({ full }) => full && `width: 100%;`};

  ${({
    variant,
    theme: {
      colors: {
        gradients: { primary },
        secondary: { red, brick },
        primary: { main, lighter, dark },
        functional: { white },
      },
      borderRadius: { full },
    },
    noStylingHover,
  }) => {
    switch (variant) {
      case 'outline':
        return `
          box-sizing: border-box;
          color: ${main};
          border: 2px solid ${main};
          border-radius: ${full};
          ${
            !noStylingHover &&
            `
            :hover{
              color: ${dark};
              border-color: ${dark};
            }
          `
          }
        `;

      case 'thick':
        return `
        height: auto;
        padding: 0;
        border-radius: 0;
        color: ${main};
        border-bottom: 2px solid ${main};
        :hover{
          color: ${dark};
          border-color: ${dark};
        }
      `;

      case 'done':
        return `
          background-color: ${lighter};
          color: ${main};
          pointer-events: none;
        `;

      case 'danger':
        return `
          background-color: ${red};
          color: ${white};
          :hover {
            background-color: ${brick};
          }
        `;

      default:
        return `
          background: ${main};
          color: ${white};
          ${
            !noStylingHover &&
            `
            :hover{
              background: ${primary};
              background-position: 0 0;
              animation: gradientX 0.5s ease-in-out;
            }
          `
          }
        `;
    }
  }};

  ${({
    disabled,
    theme: {
      colors: {
        functional: { gray4, gray6 },
      },
    },
  }) =>
    disabled &&
    `
  background-color: ${gray4};
  color: ${gray6};
  cursor: auto;
  :hover {
    opacity: 1;
    background: ${gray4};
  }
  `};

  ${({
    done,
    theme: {
      colors: {
        primary: { main, light },
      },
    },
  }) =>
    done &&
    `
  background-color: ${light};
  color: ${main};
  cursor: auto;
  `};
`;
